import config from 'config';
import { http_client } from './api';

const getList = async (jenjangID, mapelID, page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'jenjang/' +
        jenjangID +
        '/mapel/' +
        mapelID +
        '/bab?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const create = async (jenjangID, mapelID, data) => {
  return http_client.post(config.apiUrl + 'jenjang/' + jenjangID + '/mapel/' + mapelID + '/bab/', data).then((response) => {
    return response.data;
  });
};
const read = async (jenjangID, mapelID, id) => {
  return http_client.get(config.apiUrl + 'jenjang/' + jenjangID + '/mapel/' + mapelID + '/bab/' + id).then((response) => {
    return response.data;
  });
};
const update = async (jenjangID, mapelID, id, data) => {
  return http_client.patch(config.apiUrl + 'jenjang/' + jenjangID + '/mapel/' + mapelID + '/bab/' + id, data).then((response) => {
    return response.data;
  });
};
const del = async (jenjangID, mapelID, id) => {
  return http_client.delete(config.apiUrl + 'jenjang/' + jenjangID + '/mapel/' + mapelID + '/bab/' + id).then((response) => {
    return response.data;
  });
};

const changeStatus = async (jenjangID, mapelID, id, data) => {
  return http_client.post(config.apiUrl + 'jenjang/' + jenjangID + '/mapel/' + mapelID + '/bab/status/' + id, data).then((response) => {
    return response.data;
  });
};
const MapelBabService = {
  getList,
  create,
  read,
  update,
  del,
  changeStatus
};

export default MapelBabService;
